<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-card flat>
            <v-card-title class="headline">
               Nutzer
            </v-card-title>
         </v-card>

         <v-card class="mt-4">
            <v-card-title>
               <v-spacer/>
               <v-btn color="secondary" :to="{ name: 'SettingsUsersCreate'}">Neuer Nutzer
                  <v-icon right>mdi-plus</v-icon>
               </v-btn>
               <v-btn class="ml-2" color="primary" :loading="exportLoading" @click="downloadExport()">Export
                  <v-icon right>mdi-download</v-icon>
               </v-btn>
            </v-card-title>
            <v-card-title>
               <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
               ></v-text-field>
            </v-card-title>
            <SettingsUsersDataTable :headers="headers" :items="users" :search="search" :loading="usersLoading"/>
         </v-card>
      </div>
   </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   props: [],
   name: "",
   data: () => ({
      exportLoading: false,
      users: [],
      usersLoading: false,
      search: '',
      headers: [
         {text: 'Personalnummer', value: 'staff_number'},
         {text: 'Vorname', value: 'first_name'},
         {text: 'Nachname', value: 'last_name'},
         {text: 'E-Mail-Adresse', value: 'email'},
         {text: 'Organisationseinheit', value: 'orga_unit'},
         {value: 'action'},
      ],
   }),
   created() {
      this.getUsers();
   },
   computed: {
      currentDate(){
         const now = this.$moment.now();
         return this.$moment(now).format('YYYY-MM-DD');
      }
   },
   methods: {
      ...mapActions({}),
      downloadExport() {
         this.exportLoading = true;
         this.axios.get('users/export', {
            responseType: 'blob'
         }).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data], {
               type: 'application/vnd.ms-excel'
            }));
            const fileName = this.currentDate + '_Nutzer.xlsx';
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click()
            this.exportLoading = false;
         }).catch((e) => {
            console.log(e);
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      getUsers() {
         this.usersLoading = true;
         this.axios.get('/users').then((response) => {
            this.users = Object.values({...response.data.data.users});
            this.usersLoading = false;
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         });
      }
   },
}
</script>

<style scoped>

</style>
